import styled, { keyframes } from 'styled-components';
import { shade } from 'polished';

import { background } from '../../config';
import theme from '../../styles/ThemeComponents';

const fadeFromLeft = keyframes`
from {
  opacity: 0;
  transform:translateX(50) ;
}
to{
  opacity: 1;
  transform:translateX(0);
}
`;

const rotateSmoth = keyframes`
from {

  transform: rotateX(0deg) ;
}
to{
  transform: rotateX(20deg) ;
}
`;

interface IBackground {
  background?: string;
}

export const Container = styled.div<IBackground>`
  min-height: 100vh;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background: #006633;
  color: #fff;
  padding: 0px;
  width: 100%;
position: relative;
  transition: 5s all;

  >a {
    transition: 5s all;
    >img{
      transition: 5s all;
    }
  }

>div{
  position: relative;
}



  margin: auto;
z-index: 5000;
  .tenda {
    position: absolute;
    top: 12.5%;
    left: 50%;
    transform: translateX(-50%);
    width: 30%;


    >img{
      width: 100%;
    }
  }

  .livros {
    position: absolute;
    top: 70%;
    left: 52%;
    transform: translateX(-50%);
    width: 22%;

    >img{
      width: 100%;
    }
  }

  .fotografia {
    position: absolute;
    top: 7%;
    left: 2%;

    width: 25%;

    >img{
      width: 100%;
    }
  }

  .meditacao {
    position: absolute;
    top: 59%;
    left: 10%;

    width: 20%;

    >img{
      width: 100%;
    }
  }

  .cozinheiro {
    position: absolute;
    top: 7%;
    left: 70%;

    width: 25%;

    >img{
      width: 100%;
    }
  }

  .rodadagua {
    position: absolute;
    top: 57%;
    left: 75%;

    width: 20%;

    >img{
      width: 100%;
    }
  }

>a{

  &:hover{
    >img{
    transform: scale(1.1);
    }
    cursor: pointer;
    filter: drop-shadow(2px 2px 12px #fff);
  }
}

.tenda_title {
  display: none;
}

@media (max-width: 850px) {
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  >div{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: stretch;
  }

    a,img {
      position: relative !important;
      width: 100%;
      
      top: auto !important;
      left: auto !important;
      right: auto !important;
      transform: translateX(0) !important;
      
    }
    a {
      width: 45% !important;
      min-width: 45% !important;
      min-width: 45% !important;
      padding: 10px;
      margin: 5px;
      border: 1px solid rgba(0,150,0);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
    }

    .tenda{
      width: 70% !important;
      margin: 10px auto;
    }

    .fundoTenda{
      display: none;
    }

    .tenda_title{
      display: flex;
      width: 170px;
      margin: 10px auto;

    }
  }

`;
